import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 24, style }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0 });
  const [fallback, setFallback] = useState(false);
  useEffect(() => {
    // Safety net independent of IntersectionObserver: check position on mount, load, scroll and resize.
    const check = () => {
      const el = ref.current;
      if (!el || el.getBoundingClientRect().top < window.innerHeight * 1.1) setFallback(true);
    };
    check();
    const raf = requestAnimationFrame(check);
    const t = setTimeout(check, 800);
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    window.addEventListener("load", check);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
      window.removeEventListener("load", check);
    };
  }, []);
  const shown = inView || fallback;
  return (
    <motion.div
      ref={ref}
      className={className}
      style={style}
      initial={{ opacity: 0, y }}
      animate={shown ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, color = "#45ADE0", light = false }) => (
  <p className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] ${light ? "text-white/70" : "text-ink/60"}`}>
    <span className="inline-block h-[3px] w-8" style={{ background: color }} />
    {children}
  </p>
);
